import * as SearchService from "@omni/services/search/search.service";
import { IndexEntity } from "@omni/types/api/search/algolia/shared/enum/indexEntity.enum";
import { IndexType } from "@omni/types/api/search/algolia/shared/enum/indexType.enum";

import { Config } from "@/utils/config.utils";

const _indexes = {
    productsIndex: SearchService.compileIndex({
        environment: Config.general.environment,
        baseStore: Config.general.basestore,
        locale: Config.general.locale,
        indexEntity: IndexEntity.Products
    }),
    contentPagesIndex: SearchService.compileIndex({
        environment: Config.general.environment,
        baseStore: Config.general.basestore,
        locale: Config.general.locale,
        indexEntity: IndexEntity.ContentPages
    }),
    productsQuerySuggestionsIndex: SearchService.compileIndex({
        environment: Config.general.environment,
        baseStore: Config.general.basestore,
        locale: Config.general.locale,
        indexEntity: IndexEntity.Products,
        indexType: IndexType.QuerySuggesions
    })
};

export const useSearchIndexes = () => {
    return _indexes;
};
